<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("DeliveryPoint.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("DeliveryPoint.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("DeliveryPoint.Fields.code") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('DeliveryPoint.Fields.code')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="deliveryPoint.code"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'code')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ deliveryPoint.code }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("DeliveryPoint.Fields.name") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('DeliveryPoint.Fields.name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="deliveryPoint.name"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ deliveryPoint.name }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("DeliveryPoint.Fields.manager") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('DeliveryPoint.Fields.tel')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="deliveryPoint.manager"
                      :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'name')
                            .concat(errors)
                        "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ deliveryPoint.manager }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("DeliveryPoint.Fields.tel") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('DeliveryPoint.Fields.tel')"
                    rules="mobile|required"
                  >
                    <v-text-field
                      single-line
                      v-model="deliveryPoint.tel"
                      :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ deliveryPoint.tel }}
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="3"
                  :class="
                    (savable && mode == 'new')
                      ? 'font-weight-bold text-right mt-8'
                      : 'font-weight-bold text-right'
                  "
                >
                  {{ $t("DeliveryPoint.Fields.address") + $t("Global.colon") }}
                  <Required :show="savable && mode == 'new'" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable && mode == 'new'">
                  <!-- 三级地址 -->
                  <CitiesSelectGroup
                    :masterItem="deliveryPoint"
                    @provinceSelected="deliveryPoint.province_id = $event.id"
                    @citySelected="deliveryPoint.city_id = $event.id"
                    @districtSelected="deliveryPoint.area_id = $event.id"
                  />
                  <v-text-field single-line v-model="deliveryPoint.address">
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <!-- 三级地址 -->
                  <AddressText
                    :masterItem="deliveryPoint"
                    :detailAddress="deliveryPoint.address"
                  />
                </v-col>
              </v-row>

            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("DeliveryPoint.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="isView">
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !deliveryPoint.id"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$t("DeliveryPoint.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12" v-if="savable">
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !deliveryPoint.id"
                  @click="save()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("DeliveryPoint.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
// import i18n from "@/i18n";
import { mapState } from "vuex";
// import Consts from "@/consts.js";
import Required from "@/components/plugins/Required";
import DeliveryPoints from "@/api/delivery_points";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import CitiesSelectGroup from "@/components/plugins/CitiesSelects";
import AddressText from "@/components/plugins/AddressText";

export default {
  name: "deliveryPointDetail",

  props: ["value", "mode"],

  components: {
    Required,
    ValidationObserver,
    ValidationProvider,
    CitiesSelectGroup,
    AddressText,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    serverErrors: [],
    deliveryPoint: {},
  }),

  methods: {
    save() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            let deliveryPoint = JSON.parse(JSON.stringify(this.deliveryPoint));

            //校验成功再提交
            DeliveryPoints.save(deliveryPoint.id, deliveryPoint)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.deliveryPoint);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          DeliveryPoints.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.deliveryPoint = response.data.delivery_point;
              }
            }.bind(this)
          );
        } else {
          // 新建仓库，初始化默认值
          this.deliveryPoint = {};
        }
        this.$scrollTop(); //返回顶部
      },
    },
  },
};
</script>